// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__q5CS2"};